// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Lookup } from './lookup';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TransferWebRequest extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  adminId?: number;
  createdBy?: string;
  createdDate!: Date;
  data!: string;
  flags?: number;
  processed!: number;
  requestGroupUid!: string;
  requestUid!: string;
  source!: string;
  transferDate?: Date;
  typeLookupId!: number;
  typeLookup!: Lookup;
}

